import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const ContributionOperationTableHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <thead>
      <tr className="nk-tb-item tb-tnx-head">
        <th className="nk-tb-col text-left">{t('Partner')}</th>

        <th className="nk-tb-col text-right tb-col-md">{t('%ND')}</th>

        <th className="nk-tb-col text-right">{t('ToPerceive')}</th>
      </tr>
    </thead>
  );
};

export default ContributionOperationTableHeader;
